export default __webpack_public_path__ + "static/media/image17tum.d14aef1a.jpg";